import { render, staticRenderFns } from "./PinV2.vue?vue&type=template&id=4fd6e8b8&"
import script from "./PinV2.vue?vue&type=script&lang=ts&"
export * from "./PinV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports